exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttons-wrap[data-v-86f94802] {\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-right: 15px;\n  width: auto;\n  margin-right: 15px;\n  gap: 15px;\n}\n.buttons-wrap.active[data-v-86f94802] {\n  flex-direction: row;\n}", ""]);

// exports
